import { classNamesFor } from '../../../../utils/classNames';

import { tendencyIconSizes, tendencyIconVariants } from './types';

const factory = classNamesFor('TendencyIcon');

export const tendencyIconClassNames = {
  root: factory.root(),
  ...factory.toAttrClasses('tendency', ['up', 'down', 'stable'] as const),
  ...factory.toAttrClasses('variant', tendencyIconVariants),
  ...factory.toAttrClasses('size', tendencyIconSizes),
  upIsPositive: factory.attribute('upIsPositive'),
};
